// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1124":"87f3e25a9c101de3","6457":"ada2ed2743a46cde"}[chunkId] + ".js";
};